import Deepstream from "../libs/deepstream/deepstream";
import Meeting from "../libs/deepstream/meeting";
import Preview from "../libs/deepstream/preview";
import Sequence from "../libs/deepstream/sequence";

export default async ({ Vue, redirect, store }) => {
  // deepstream singleton
  const deepstream = new Deepstream(
    `${process.env.DEEPSTREAM_HOST}:${process.env.DEEPSTREAM_PORT}`,
    redirect
  );
  Vue.prototype.$deepstream = deepstream;
  Deepstream.getInstance = () => {
    return deepstream;
  };
  const meeting = new Meeting(deepstream, store);
  Vue.prototype.$meeting = meeting;
  Meeting.getInstance = () => {
    return meeting;
  };
  const preview = new Preview(deepstream, store);
  Vue.prototype.$preview = preview;
  Preview.getInstance = () => {
    return preview;
  };
  const sequense = new Sequence(deepstream, store);
  Vue.prototype.$sequense = sequense;
  Sequence.getInstance = () => {
    return sequense;
  };
};
